<template>
    <div class="datepicker"
        :class="{
            'input-field--readonly':    readonly,
            'input-field--disabled':    disabled,
            'input-field--vertical':    vertical,
            'input-field--stretch':     stretch,
            'input-field--spacing-off': spacingOff,
            'input-field--text-group':  textGroup
        }">
        <input :id="id" :name="name" :disabled="disabled" :placeholder="dateFormat" @input="input" class="datepicker__input" v-mask="format" v-model="modelValue" type="tel"/>
    </div>
</template>

<script>
export default {
    props : {
        name : {
           type : String,
           required : false,
           default : '' 
        },
        value : {
            default : ''
        },
        type : {
            type : String,
            default : 'date',
            required : false
        },
        id: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: false
        },
        readonly: {
            type: Boolean,
            required: false
        },
        disabled: {
            type: Boolean,
            required: false
        },
        stretch: {
            type: Boolean,
            required: false
        },
        spacingOff: {
            type: Boolean,
            required: false
        },
        textGroup: {
            type: Boolean,
            required: false
        },
        vertical: {
            type: Boolean,
            required: false
        },
        masked : {
            type : Boolean,
            required : false,
            default : false
        }
    },
    data : function () {
        return {
            modelValue : null
        };
    },
    computed : {
        format : function () {
            return this.type === 'date'?(this.masked?periodo + '-' + mes:'####-##') + '-##':(this.type === 'datetime'?(this.masked?periodo + '-' + mes:'####-##') + '-## ##:##':'##:##');
        },
        dateFormat : function () {
            return this.type === 'date'?(this.masked?periodo + '-' + mes:'YYYY-MM') + '-DD':(this.type === 'datetime'?(this.masked?periodo + '-' + mes:'YYYY-MM') + '-DD HH:mm':'HH:mm');
        }
    },
    mounted : function () {
        let date = this.value;
        if (this.value !== '' && this.value !== null) {
            if (date !== null && date.length === 10)
                date += ' 00:00:00';
            else if (date !== null && date.length === 5)
                date = moment(new Date()).format('YYYY-MM-DD') + ' ' + this.value;
            let fecha = new Date((date instanceof Date)?moment(date).format(this.dateFormat):date);
            if (fecha == 'Invalid Date')
                fecha = moment(new Date()).format(this.dateFormat);
            else 
                fecha = moment(fecha).format(this.dateFormat);
            this.modelValue = fecha;
            this.$emit('input', this.modelValue);
        }
    },
    watch : {
        value : function (value) {
            this.modelValue = (value instanceof Date)?moment(value).format(this.dateFormat):value;
        }
    },
    methods : {
        input : function () {
            this.$emit('input', this.modelValue);
        }
    },
    updated : function () {
        let that = this;
        let element = document.getElementById(this.id);
        if (element !== undefined && element !== null) {
            element.onblur = function () {
                if (that.type !== 'time') {
                    if (that.modelValue !== null && (that.modelValue.length === 10 || that.modelValue.length === 16)) {
                        let date = new Date(that.modelValue);
                        if (date == 'Invalid Date')
                        {
                            that.modelValue = moment(new Date()).format(that.dateFormat);
                            that.$emit('input', that.modelValue);
                        }
                    } 
                    else if (that.modelValue !== null && that.modelValue.length > 0)
                    {
                        that.modelValue = moment(new Date()).format(that.dateFormat);
                        that.$emit('input', that.modelValue);
                    }
                }
                else if(that.modelValue !== null && that.modelValue.length === 5) {
                    let date = new Date('2019-01-01 ' + that.modelValue);
                    if(date == 'Invalid Date')
                    {
                        that.modelValue = moment(new Date()).format(that.dateFormat);
                        that.$emit('input', that.modelValue);
                    }
                }
                else if (that.modelValue !== null && that.modelValue.length > 0)
                {
                    that.modelValue = moment(new Date()).format(that.dateFormat);
                    that.$emit('input', that.modelValue);
                }
            };
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/DatePicker.vue